<template>
  <div class="card mb-5 mb-xxl-8">
    <!--begin::Body-->
    <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
      <!--begin::Card header-->
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('shop.add_product') }}</h3>
        </div>
        <div class="card-toolbar">
          <router-link :to="'/admin/shops/'+ $route.params.id + '/view/products'"  class="btn btn-sm btn-light mr-5" > {{ $t("back") }} </router-link>
          <button v-show="!shop?.archive" @click="addProductsData" id="kt_submit_create_add_prod" class="btn btn-sm btn-primary m-2">
              <span class="indicator-label">{{ $t('button.save') }}</span>
              <span class="indicator-progress">{{  $t('loading') }}
                
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
          </button>
        </div>
      </div>

      <div class="card-body">
        <!--begin::Layout-->
        <div class="row">
          <!--begin::Input group-->
          
          <div class="" data-kt-ecommerce-catalog-add-product="auto-options">
            <!--begin::Label-->
            <div id="kt_ecommerce_add_product_options">
              <div class="row mb-5">
                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <label class="form-label">{{ $t('product.categories') }}</label>
                    <select class="form-select form-select-solid kt_select2" data-control="select2"
                        v-model="formCreateProductData.categories"  name="categories[]"
                        :data-placeholder="$t('product.select_category')" data-allow-clear="true"
                        data-search="true"   multiple="multiple"
                    >
                      <option v-for="category in categories" :key="category.id" :value="category.id"> {{ category.name }} </option>
                    </select>
                  </div>
                </div>
                <div class="row col-md-6 col-sm-12">
                  <div class="col-md-8 col-sm-12" >
                    <label class="form-label">{{ $t('product.taxes') }}</label>
                    <select class="form-select form-select-solid kt_select2" data-control="select2" name="taxes[]" data-search="true"    v-model="formCreateProductData.taxes" data-allow-clear="true" multiple="multiple">
                      <option v-for="taxe in getTaxes" :key="taxe.id" :value="taxe.id">{{ taxe.title }} </option>
                    </select>
                  </div>
                  <div class="col-md-2 col-sm-12 mt-10">
                    <div class=" input-group-append">
                      <button @click="openCreateTaxetModal" type="button" class="btn btn-sm btn-icon btn-light-primary">
                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr088.svg-->
                        <span class="svg-icon svg-icon-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor" />
                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" />
                                  </svg>
                                </span>
                        <!--end::Svg Icon-->
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                  <!--begin::Table head-->
                  <thead>
                    <tr class="fw-bold text-muted">
                      <th class="w-25px" v-if="productSaleEments_collection.length">
                          <div class="form-check form-check-sm form-check-custom form-check-solid">
                              <input class="form-check-input" type="checkbox" @click="allProductsData" v-model="allProducts" data-kt-check="true" data-kt-check-target=".widget-13-check" />
                          </div>
                      </th>
                      <th class="min-w-200px">{{ $t('product.name')}}</th>
                      <th class="min-w-300px"> {{ $t('product.modification')}} </th>
                    </tr>
                  </thead>
                  <!--end::Table head-->
                  <tbody>
                    <tr v-for="(product, key) in productSaleEments_collection" :key="key">
                      <td class="w-25px">
                          <div class="form-check form-check-sm form-check-custom form-check-solid">
                              <input class="form-check-input widget-13-check" type="checkbox" @click="take_product(product)" v-model="product.checked" />
                          </div>
                      </td>
                      <td class="min-w-150px">
                          <a href="#" class="text-dark fw-bold text-hover-primary fs-6">{{ product.name }}</a>
                      </td>
                      <td class="row min-w-200px">
                        <div class="col-md-2 col-sm-12">
                          <label class="form-label"> {{ $t('product.price') }}</label>
                          <input type="number" class="form-control form-control-solid" v-model="product.price" required :disabled="!(product.checked && !shop?.archive)" />
                        </div>

                        <template v-if="$hasShopModule('pos.stock')">
                          <div class="col-md-2 col-sm-12">
                            <label class="form-label"> {{ $t('product.stock_initial') }}</label>
                            <input :data-key="key"  type="number" class="form-control form-control-solid"  v-model="product.stock_initial" required :disabled="!(product.checked && !shop?.archive)" />
                          </div>

                          <div class="col-md-2 col-sm-12">
                            <label class="form-label"> {{ $t('product.stock_security') }}</label>
                            <input :data-key="key" type="number" class="form-control form-control-solid" v-model="product.stock_security" required :disabled="!(product.checked && !shop?.archive)" />
                          </div>

                          <div class="col-md-2 col-sm-12">
                            <label class="form-label"> {{ $t('product.stock_alert') }}</label>
                            <input type="number" class="form-control form-control-solid" v-model="product.stock_alert" required  :disabled="!(product.checked && !shop?.archive)" />
                          </div>
                        </template>
                      </td>
                    </tr>

                    <tr v-if="(!productSaleEments_collection.length && !shop?.archive)">
                      <td class="min-w-25px"></td>
                      <td class="min-w-200px">
                        <div class="text-center pt-5">
                          <div><img src="/assets/media/illustrations/sketchy-1/illustration1-custom.svg?v=2" style="width: 150px; height: 150px;" alt=""/></div>
                            {{ $t('product.stock_alert') }}
                        </div>
                      </td>
                      <td class="min-w-300px"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!--end::Repeater-->
          </div>
          <!--end::Input group-->
        </div>
        <!--end::Layout-->
      </div>

      <div class="modal fade" id="createTaxeModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog" >
          <form @submit.prevent="createTaxData" class="form">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('button.add') }}</h5>

                <!--begin::Close-->
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-2x"></span>
                </div>
                <!--end::Close-->
              </div>
              <div class="modal-body">

                <div class="d-flex flex-column mb-8 fv-row">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{$t('taxe.title')}}</span>
                  </label>
                  <!--end::Label-->
                  <input type="text" class="form-control form-control-solid" v-model="formCreateTaxeData.title" required :placeholder="$t('taxe.title_placeholder')" />
                </div>
                <div class="d-flex flex-column mb-8 fv-row">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('taxe.type') }}</span>
                  </label>
                  <!--end::Label-->
                  <select data-dropdown-parent="#createTaxeModal" name="tax_type" class="form-select form-select-solid kt_select2" data-control="select2" v-model="formCreateTaxeData.type" required data-search="true"   :data-placeholder="$t('taxe.type_placeholder')" >
                    <option></option>
                    <option value="amount">{{ $t('taxe.type_amount') }}</option>
                    <option value="percent">{{ $t('taxe.type_percent') }}</option>
                  </select>              </div>
                <div class="d-flex flex-column mb-8 fv-row"  v-if="formCreateTaxeData.type === 'amount'" >
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('taxe.amount') }}</span>
                  </label>
                  <!--end::Label-->
                  <input type="text" @keypress="onlyNumber" class="form-control form-control-solid" v-model="formCreateTaxeData.amount" required :placeholder="$t('taxe.amount_placeholder')" />
                </div>
                <div class="d-flex flex-column mb-8 fv-row"  v-if="formCreateTaxeData.type === 'percent'">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('taxe.percent') }}</span>
                  </label>
                  <!--end::Label-->

                  <div class="input-group mb-5">
                    <input type="text" @keypress="onlyNumber"  class="form-control form-control-solid" v-model="formCreateTaxeData.amount" required :placeholder="$t('taxe.percent_placeholder')" />
                    <span class="input-group-text" id="basic-addon2">%</span>
                  </div>
                </div>
                <div class="d-flex flex-column mb-8 fv-row">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('taxe.country') }}</span>
                  </label>
                  <!--end::Label-->
                  <select class="form-select form-select-solid kt_select2"
                          data-control="select2" name="countries[]"
                          v-model="formCreateTaxeData.countries"
                          :data-placeholder="$t('taxe.countries_placeholder')"
                          data-allow-clear="true" multiple="multiple"
                          data-dropdown-parent="#createTaxeModal"
                          data-search="true"
                  >
                    <option  v-for="country in getCountries" :key="country.id"
                             :value="country.id">{{ country.name }} </option>
                  </select>

                </div>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                <button type="submit" id="kt_submit_create_taxe" class="btn btn-sm btn-primary fw-bolder">
                  <span class="indicator-label">{{ $t('button.save') }}</span>
                  <span class="indicator-progress">{{  $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import {mapActions,mapGetters} from "vuex";

export default {
  name: "Products",
  data(){
    return{
      formCreateProductData: {
        id: this.$route.params.id,
        categories: [],
        taxes: [],
        productSaleElements : [],
      },
      isLoading: false,
      categories: {},
      products: {},
      productSaleEments_collection: {},
      taxes: {},
      formCreateTaxeData: {
        title: '',
        amount : '',
        type : '',
        countries : []
      },
      status: null,
      allProducts: false
    }
  },
  computed: {
    productsFormToString(){
      return JSON.stringify(this.formCreateProductData)
    },

    ...mapGetters('countries', [
      'getCountries'
    ]),
    ...mapGetters('taxes', ['getTaxes'])

  },

  watch: {
    productsFormToString : function(){
        this.$nextTick(() => {
          this.initSelect2()
        })
    },

    'formCreateProductData.categories' : async function(value){
        if(value){
          let data = {
            id: this.$route.params.id,
            categories: value
          }
          let res1 = await this.getShopCategoriesProducts(data)
          this.productSaleEments_collection = res1.data.productSaleEments_collection
        }
    },

    '$route.params.id' : function(newId, oldId){
      // Vue Router réutilise ce composant quand on passe de la fiche d'une
      // boutique à une autre (même route, seul :id change) — sans ce watcher,
      // le formulaire garde les catégories/produits de l'ancienne boutique.
      if (newId && newId !== oldId) this.initForShop()
    },

  },
  async mounted() {
    await this.initForShop()

      this.initSelect2()

      $(".kt_select2").select2()
    
      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'countries[]':
            let countries = [];
            for (var k = 0, kLen = e.target.selectedOptions.length; k<kLen; k++) {
              if(e.target.selectedOptions[k].value != '' || e.target.selectedOptions[k].value != undefined){
                countries.push(e.target.selectedOptions[k].value);
              }
            }
            this.formCreateTaxeData.countries = countries
            break;
          case 'tax_type':
            this.formCreateTaxeData.type = e.target.value
            break;
          default:
            break;
        }
      });
    $('body .pre').css('display', 'none')
  },

  methods: {
    ...mapActions('tenantModule', ['loadShopModules']),
    ...mapActions('shop', [
      'showShop',
      'addProductsInShop',
      'getShopCategoriesProducts'
    ]),

    ...mapActions('countries', [
      'loadCountries',
    ]),

    ...mapActions('taxes',[
        'loadTaxes',
        'createTaxe'
    ]),

    async initForShop() {
      $('body .pre').css('display', 'block')
      await this.loadTaxes()
      await this.loadShopModules(this.$route.params.id)
      let response = await this.showShop(this.$route.params.id)
      this.categories = response.data.categories
      this.products = response.data.products
      this.status = response.data.shop.archive
      $('body .pre').css('display', 'none')
    },

    openCreateTaxetModal(){
      $('#createTaxeModal').modal('toggle')
    },

    initSelect2()
    {

      KTApp.initSelect2()

      $(".kt_select2").select2()

      $(".kt_select2").select2().select2()

      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'productSaleElements':
            this.formCreateProductData.productSaleElements[e.target.getAttribute('data-key')].productSaleElement_id = e.target.value
            break;
            case 'taxes[]':
              let result = [];
              for (var i = 0, iLen = e.target.selectedOptions.length; i < iLen; i++) {
                if (e.target.selectedOptions[i].value != '' || e.target.selectedOptions[i].value != undefined) {
                  result.push(e.target.selectedOptions[i].value);
                }
              }
              this.formCreateProductData.taxes = result
              break;
          case 'categories[]':
            let catresult = [];
            for (var i = 0, iLen = e.target.selectedOptions.length; i < iLen; i++) {
              if (e.target.selectedOptions[i].value != '' || e.target.selectedOptions[i].value != undefined) {
                catresult.push(e.target.selectedOptions[i].value);
              }
            }
            this.formCreateProductData.categories = catresult
            break;
          default:
            break;
        }
      });
    },

    async addProductsData(){
      this.$loading('kt_submit_create_add_prod')
      let response = {}
      let productElements = this.productSaleEments_collection.filter(function(item) {
          return item.checked === true;
      });
      productElements?.forEach((item, key)=> {
          const payload = {
              productSaleElement_id : item.id,
              price :  item.price,
          }
          if (this.$hasShopModule('pos.stock')) {
              payload.stock_initial = item.stock_initial
              payload.stock_alert = item.stock_alert
              payload.stock_security = item.stock_security
          }
          this.formCreateProductData?.productSaleElements?.push(payload)
      })

      try{
        response = await this.addProductsInShop(this.formCreateProductData)
        window.toastr['success'](i18n.global.t("notification.shop_add_product"))
        this.$router.push('/admin/shops/' + this.$route.params.id + '/view')
        
        this.$stopLoading('kt_submit_create_add_prod')
        return true
      }catch(err){
        this.$stopLoading('kt_submit_create_add_prod')
        this.formCreateProductData.productSaleElements = []
        this.isLoading = false;
        
      }
    },

    async createTaxData(){
      this.$loading('kt_submit_create_taxe')

      let response = {}

      try{
        response = await this.createTaxe(this.formCreateTaxeData)
        window.toastr['success'](response.data.message)

        let res = await this.showShop(this.$route.params.id)
        this.taxes = res.data.taxes

        this.formCreateProductData.taxes.push(response?.data?.taxe?.id)

        $('#createTaxeModal').modal('toggle')
        this.formCreateTaxeData = {
          name: '',
          type: '',
          amount: '',
        }
        this.$stopLoading('kt_submit_create_taxe')
        return true

      } catch(err){
        this.$stopLoading('kt_submit_create_taxe')
        window.toastr['error'](err)
        this.formCreateProductData.productSaleElements = []

      }
    },

    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    },

    take_product(product){
      if(product.checked === true){
        product.checked = false
        this.allProducts = false
      }else{
        product.checked = true
      }  
    },

    allProductsData(){
      if(this.allProducts === true){
          this.allProducts = false
          this.formCreateProductData.productSaleElements = []
          this.productSaleEments_collection?.forEach((item, key)=> {
            item.checked = false
          })
        }else{
          this.allProducts = true
          this.productSaleEments_collection?.forEach((item, key)=> {
            item.checked = true
          })
        }
    }
  }
}
</script>

<style scoped>

</style>